import { PropsWithChildren } from "react";
import { PageHeaderContent } from "../header/page-header-content";
import { PageFooterContent } from "../footer/page-footer-content";
import {Helmet} from "react-helmet";
import {useLocation} from "react-router-dom";

interface IEltrpPageProps extends PropsWithChildren{
    metaTitle?: string;
    metaDescription?: string;
}

export const EltrpPage = ({metaTitle, metaDescription, children}: IEltrpPageProps) => {
    const location = useLocation();
  return (
    <div className="container">
        <Helmet>
            <title>{metaTitle}</title>
            <meta name="description" content={metaDescription} />
            <link rel="canonical" href={"https://eltrp.org" + location.pathname + location.search}/>
        </Helmet>
      <header id={"top"}>
        <PageHeaderContent />
      </header>
      <main>{children}</main>
      <footer>
        <PageFooterContent />
      </footer>
    </div>
  );
};
